import React, { Suspense, lazy } from 'react'
import { FormattedHTMLMessage, Modal } from '@web/walter-ui-kit'
import Preloader from './Preloader'
import { lang } from './lang'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'

const Content = lazy(() => import('./Content'))

function LocaleModal() {
    const { isOpen, hide } = useModal(ModalTypes.locale)

    return (
        <Modal
            size="s"
            type="dialog"
            onClose={hide}
            isOpen={isOpen}
            withHeaderBorder={false}
            dataPointer="locale_modal"
            withContentPaddings={false}
            title={<FormattedHTMLMessage {...lang.title} />}
        >
            <Suspense fallback={<Preloader />}>
                <Content />
            </Suspense>
        </Modal>
    )
}

export default LocaleModal
